import React, { useContext, useReducer } from "react";

const helperContext = React.createContext();

const initialState = {
  runningQuesId: "", // ids or submitted
  isFullScreen: "",
  FSRemoveCount: 0,
  isUserInput: false,
  isNextQues: false, // for handle next question
  totalTap: 0, //for CPT TEST help in count total user tap
  testType: "", // "CALIBRATION" "DEMO" check weather the test is demo calibration or actual test
  fnQuesId: "11862", // initial id for dummy test
  //tabs movement
  mapprTab: "1",
  dashboardTab: "1",
  offSetHeight: 0,
  queIdAfterFnTest: "",

  //test section
  testSection: "",

  //audio test helper
  // FIXME
  isStartTime: false, // related to audio test
  isReplay: true, // related to audio recording test
  isAudioEnded: false, // related to audio recording test
  isAudioTest: false, // check for audio and non-audio test
  faceData: false, // check for audio and non-audio test
  audioQuePlay: false, // for audio replay n cases

  // speed image recall shuffeled image str
  shuffeledImage: "empty string",

  // digit memory span
  showingNumbers: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "OFF_HEIGHT": {
      return { ...state, offSetHeight: action.payload };
    }
    case "RUNNING_QUES_ID": {
      return { ...state, runningQuesId: action.payload };
    }
    case "FN_QUES_ID": {
      return { ...state, fnQuesId: action.payload };
    }
    case "TEST_SECTION": {
      return { ...state, testSection: action.payload };
    }
    case "SET_QUE_ID_AFTER_FN": {
      return { ...state, queIdAfterFnTest: action.payload };
    }

    case "FULLSCREEN_DISTURB": {
      return { ...state, FSRemoveCount: state.FSRemoveCount + 1 };
    }
    case "RESET_FS_REMOVE_COUNT": {
      return { ...state, FSRemoveCount: 0 };
    }
    case "USER_INPUT": {
      return { ...state, isUserInput: action.payload };
    }
    case "TEST_TYPE": {
      return { ...state, testType: action.payload };
    }
    case "MAPPR_TAB_MOVE": {
      return { ...state, mapprTab: action.payload };
    }

    case "DASHBOARD_TAB_MOVE": {
      const testType = () => {
        if (action.payload === "1") {
          return true;
        } else {
          return false;
        }
      };
      return {
        ...state,
        dashboardTab: action.payload,
        isAudioTest: testType(),
      };
    }

    case "IS_NEXT_QUES": {
      return { ...state, isNextQues: action.payload };
    }

    case "IS_AUDIO_ENDED": {
      return { ...state, isAudioEnded: action.payload };
    }
    case "IS_REPLAY": {
      return { ...state, isReplay: action.payload };
    }
    case "IS_START_TIME": {
      return { ...state, isStartTime: action.payload };
    }
    case "SET_TOTAL_TAP": {
      // console.log("totalTap inside reducer", state.totalTap + 1);
      return { ...state, totalTap: state.totalTap + 1 };
    }
    // for resetting totalTap
    case "RESET_TOTAL_TAP": {
      console.log("RESETTING TOTAL TAP");
      return { ...state, totalTap: 0 };
    }
    // speed image recall shuffeled image str
    case "SET_SHUFFELED_IMAGE": {
      console.log("que_ids", action.payload);
      return { ...state, shuffeledImage: action.payload };
    }
    case "RESET_SHUFFELED_IMAGE": {
      return { ...state, shuffeledImage: "empty string" };
    }
    case "FACE_DATA": {
      return { ...state, faceData: action.payload };
    }
    case "AUDIO_QUE_PLAY": {
      return { ...state, audioQuePlay: action.payload };
    }

    case "RESET_AUDIO_STAT": {
      return {
        ...state,
        isStartTime: false,
        isReplay: true,
        isAudioEnded: false,
        isAudioTest: false,
        faceData: false,
        audioQuePlay: false,
      };
    }
    
    case "SHOWING_NUMBERS": {
      return {...state, showingNumbers: action.payload};
    }

    default:
      return state;
  }
};

export function HelperProvider(props) {
  const [helperC, dispatchHelper] = useReducer(reducer, initialState);
  return (
    <helperContext.Provider value={{ helperC, dispatchHelper }} {...props} />
  );
}

export function HelperContext() {
  const context = useContext(helperContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
